const translations = {
    workOrderNumber: 'Work Order Number (Third Party)',
    workOrderNumberMax: 'Work Order Number must be less than {{charMax}} characters'
};

export default translations;
